import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { Location } from '../models/location';
import { ServerData } from '../models/paging/server-data';

import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';

@Injectable()
export class LocationService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }
  public getFromCompany(company_Id: number): Promise<Location[]> {
    return new Promise((resolve, reject) => {
      this.http.get<Location[]>(environment.apiUrl + "location/getall?company_Id=" + company_Id).subscribe(data => {
        resolve(data)
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public getAll(): Promise<Location[]> {
    return new Promise((resolve, reject) => {
      this.http.get<Location[]>(environment.apiUrl + 'location/getall').subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public get(id: number): Promise<Location> {
    return new Promise((resolve, reject) => {
      this.http.get<Location>(environment.apiUrl + 'location/get?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public save(location: Location): Promise<Location> {
    return new Promise((resolve, reject) => {
      if (location.is_edit) {
        this.http.put<Location>(environment.apiUrl + 'location/put', location).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully updated location');
        }, error => {
          //console.log(error);
          reject();
        });
      } else {
        this.http.post<Location>(environment.apiUrl + 'location/post', location).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully added location');
        }, error => {
          //console.log(error);
          reject();
        });
      }
    });
  }


  public getResults(page: Page, name: string, company_Id: number, postcode: string = ''): Promise<PagedData<Location>> {
    const pagedData = new PagedData<Location>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Name'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&name=' + name;
      params += '&company_Id=' + company_Id;
      params += "&postcode=" + postcode;

      this.http.get<ServerData>(environment.apiUrl + 'location/gettable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });


  }
}
